import { IImage } from '../offer';

export enum EGallerySection {
  Layout = 'layout',
  FloorPlan = 'floorPlan',
  Tour = 'tour',
  JKGallery = 'jkgallery',
  Gallery = 'gallery',
  OffersPhotos = 'offersPhotos',
}

export interface IGalleryItem {
  type: EGallerySection;
  id: string;
  title: string;
  media: IImage[];
}
